import { z } from 'zod';
import { CommunicationTemplateSchema, DocumentTemplateSchema, NoteTemplateSchema, TimelineTemplateSchema } from '../aggregates/template.js';
const extendProps = {
    revision: z.number(),
};
export const ListTemplateRevisionsResponseSchema = z
    .discriminatedUnion('type', [
    CommunicationTemplateSchema.extend(extendProps),
    DocumentTemplateSchema.extend(extendProps),
    NoteTemplateSchema.extend(extendProps),
    TimelineTemplateSchema.extend(extendProps),
])
    .array();
export const ListTemplateRevisionsApiSchema = {
    params: z.object({
        id: z.string(),
    }),
    response: z
        .union([
        CommunicationTemplateSchema.extend(extendProps),
        DocumentTemplateSchema.extend(extendProps),
        NoteTemplateSchema.extend(extendProps),
        TimelineTemplateSchema.extend(extendProps),
    ])
        .array(),
};
export const ListTemplateRevisionsRequestSchema = ListTemplateRevisionsApiSchema.params;
